import { Button, Typography } from '@mui/material'
import { ActivityButton } from 'components/ActivityButton'
import { Modal } from 'components/Modal/Modal'
import { ModalFullBody } from 'components/Modal/ModalFullBody'
import { ModalFullFooter } from 'components/Modal/ModalFullFooter'
import { ModalFullHeader } from 'components/Modal/ModalFullHeader'
import { useLayout } from 'hooks/useLayout'

interface LocationSweepstakesConfirmationModalProps {
  isModalOpen: boolean
  toggleIsOpen: () => void
  onConfirm: () => void
  onCancel: () => void
  drawingName: string
  deleteIsActive: boolean
}

export const LocationSweepstakesDrawingSectionDeleteModal = ({
  isModalOpen,
  toggleIsOpen,
  drawingName,
  onConfirm,
  onCancel,
  deleteIsActive,
}: LocationSweepstakesConfirmationModalProps) => {
  const { isMobile } = useLayout()
  const heightModal = isMobile ? '100%' : '30%'
  const title = 'Delete Drawing?'
  const bodyText = `Are you sure you want to delete ${drawingName}?`
  return (
    <Modal
      isOpen={isModalOpen}
      toggleIsOpen={toggleIsOpen}
      sx={{
        width: { xs: '90vw', sm: '40%' },
      }}
    >
      <ModalFullHeader toggleIsOpen={toggleIsOpen} title={title} />
      <ModalFullBody heightModal={heightModal}>
        <Typography variant="h3">{bodyText}</Typography>
      </ModalFullBody>
      <ModalFullFooter>
        <Button variant="text" onClick={onCancel}>
          Cancel
        </Button>
        <ActivityButton
          active={deleteIsActive}
          variant="contained"
          onClick={onConfirm}
        >
          Delete
        </ActivityButton>
      </ModalFullFooter>
    </Modal>
  )
}
